/**
 * Bridge between our semantic color tokens and Fluent UI 9's chart palette.
 * Every wrapper goes through here so a "degraded" bar in BusinessPage looks
 * the same as a "degraded" line in ResourcesPage.
 */

import { DataVizPalette, getColorFromToken } from '@fluentui/react-charts';

import type { ChartTone } from './types';

const TONE_TO_FLUENT_PALETTE: Record<ChartTone, string> = {
  neutral: DataVizPalette.color9,
  brand: DataVizPalette.color1,
  healthy: DataVizPalette.success,
  degraded: DataVizPalette.warning,
  unhealthy: DataVizPalette.error,
};

/** Resolve a tone to a concrete CSS color via Fluent's data-viz palette. */
export function toneToColor(tone: ChartTone): string {
  return getColorFromToken(TONE_TO_FLUENT_PALETTE[tone]);
}

/**
 * Stable multi-series palette in token order — pass an index to get the same
 * color for the Nth series across charts on the same page. Wraps around.
 */
const SERIES_TOKENS: readonly string[] = [
  DataVizPalette.color1,
  DataVizPalette.color2,
  DataVizPalette.color3,
  DataVizPalette.color4,
  DataVizPalette.color5,
  DataVizPalette.color6,
  DataVizPalette.color7,
  DataVizPalette.color8,
];

export function seriesColor(index: number): string {
  if (SERIES_TOKENS.length === 0) {
    return getColorFromToken(DataVizPalette.color1);
  }
  return getColorFromToken(SERIES_TOKENS[index % SERIES_TOKENS.length]);
}
